import {Component, inject, OnInit} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from '../../core/services/auth/auth.service';
import { SidebarService } from '../../core/services/sidebar/sidebar.service';
import { ThemeService } from '../../core/services/theme/theme.service';
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { InputSwitchModule } from 'primeng/inputswitch';
import { filter, take } from 'rxjs';
import { TenantService } from '../../core/services/tenant.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    NgxSkeletonLoaderModule,
    FormsModule,
    InputSwitchModule,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  private demoInfoService = inject(TenantService);
  demoDaysLeft = this.demoInfoService.daysLeft;
  hostname = window.location.hostname;
  tenant=  this.hostname.split('.')[0].toLowerCase()
  private auth = inject(AuthService);
  private router = inject(Router);
  private themeService = inject(ThemeService);
  sidebarService = inject(SidebarService);
  denominazione = this.auth.denominazione;
  email = this.auth.email;
  appReady = false;
  initials = this.auth.initials;
  darkMode = this.themeService.darkMode;

  constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd), take(1))
      .subscribe(() => {
        this.appReady = true;
      });
  }

  ngOnInit() {
    this.demoInfoService.load(this.tenant).subscribe();
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['/login']);
  }

  toggleSidebar() {
    this.sidebarService.toggle();
  }

  setDarkMode(enabled: boolean) {
    this.themeService.setDarkMode(enabled);
  }
}
